import React, { useEffect, useState, useRef } from 'react';
import 'src/assets/images/styles/SplashScreen.css';
import loadingGif from 'src/assets/images/other/loading-response.gif';

const SplashScreen = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [showCircle, setShowCircle] = useState(false);
  const splashRef = useRef(null);
  const currentYear = new Date().getFullYear();

  // 1. Basic user-agent check (for Googlebot, Bingbot, etc.)
  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    // Some typical user-agent keywords for search engine crawlers
    const isBot = /googlebot|bingbot|crawler|spider|robot|crawling|mediapartners-google/i.test(userAgent);

    if (isBot) {
      // If it's a known bot, hide the splash immediately
      setIsVisible(false);
      return;
    }

    localStorage.setItem('darkMode', 'true');
    // 2. Otherwise, run your normal splash logic
    const imgTimer = setTimeout(() => {
      const image = splashRef.current.querySelector('.zosaimage img');
      image.style.opacity = '1';
      image.style.transform = 'scale(1)';
    }, 200);

    const textTimer = setTimeout(() => {
      const text = splashRef.current.querySelector('.wrapper');
      text.style.opacity = '1';
      text.style.transform = 'translateY(0)';
    }, 3000);

    const circleTimer = setTimeout(() => {
      setShowCircle(true);
    }, 5000);

    const transitionTimer = setTimeout(() => {
      document.getElementById('splash-screen-body').style.animation =
        'zoomOutFade 1s forwards';
    }, 5500);

    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 6500);

    return () => {
      clearTimeout(imgTimer);
      clearTimeout(textTimer);
      clearTimeout(circleTimer);
      clearTimeout(transitionTimer);
      clearTimeout(hideTimer);
    };
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div id="splash-screen-body" ref={splashRef}>
      {showCircle && <div className="expanding-circle"></div>}
      <section className="splash-section">
        <div className="zosaimage splash-image">
          <img src={loadingGif} alt="zosaloading" />
        </div>
        <div className="wrapper top-message">
          <div className="caption__w">WELCOME TO</div>
          <div className="caption__v">
            <ul className="text_v">
              <li>ZOSA</li>
            </ul>
          </div>
        </div>
        <div className="wrapper bottom-message">
          <div className="caption__w">THERE'S ALWAYS ANOTHER LAYER TO DISCOVER.</div>
        </div>
      </section>

      <div
        style={{
          position: 'absolute',
          bottom: '3%',
          width: '100%',
          textAlign: 'center',
          fontSize: '0.875rem',
          color: '#4f5d75',
        }}
      >
        © ZOSA {currentYear}
      </div>
    </div>
  );
};

export default SplashScreen;
